import { Disclosure, useStoreState, type DisclosureStore } from '@ariakit/react';
import { Spindown } from '#components/atoms/spindown/Spindown.tsx';
import { DetailList } from '#components/patterns/detail-list/DetailList.tsx';
import { DetailListRow } from '#components/patterns/detail-list/DetailListRow.tsx';
import styles from './StatsDisclosureTop.module.css';

type Props = {
  disclosure: DisclosureStore;
};

export function StatsDisclosureTop({ disclosure }: Props) {
  const isOpen = useStoreState(disclosure, 'open');

  return (
    <Disclosure store={disclosure} className={styles.StatsDisclosureTop_disclosure}>
      <Spindown isExpanded={isOpen} className={styles.StatsDisclosureTop_spindown} />
      <DetailList>
        <DetailListRow label="Stats type" value="" />
      </DetailList>
    </Disclosure>
  );
}
